import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { getUserMailboxInfo } from 'owa-client-ids';
import getMailboxByIdentityOperation from 'owa-service/lib/operation/getMailboxByIdentityOperation';
export default function getMailboxForwardingConfigurationService() {
    return getMailboxByIdentityOperation({
        Header: getJsonRequestHeader(),
        Identity: {
            RawIdentity: getUserMailboxInfo().mailboxId,
        },
    }).then(function (responseMessage) {
        if (responseMessage.WasSuccessful) {
            return responseMessage.MailboxOptions;
        }
        else {
            throw new Error("getMailboxForwardingConfigurationService " + responseMessage.ErrorCode + " " + responseMessage.ErrorMessage);
        }
    });
}
//# sourceMappingURL=getMailboxForwardingConfigurationService.js.map